<template>
  <div class="popup-form">
    <div class="content-form-popup">
      <div class="header-text">
        <div class="back-button-wrapper pointer" @click="closePopupWithInfo">
          <img
            class="nav-link-icon filter-primary"
            src="@/images/modal-close.svg"
            alt=""
          />
        </div>
        <div class="blackcolor pop-800">Pridanie spolužiadateľa</div>
      </div>
      <div class="client-name-block">
        <img
          src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f37_avatar%20cropped.png"
          loading="lazy"
          alt=""
          class="image-10"
        />
        <div class="div-block-28">
          <div class="bold">{{ clientInfo.type }}</div>
        </div>
      </div>
      <client-picker @client-picked="selectedClient = $event" @busy="clientBusy = $event" :disabled="saving" complex />
      <p v-if="saveError" class="clientError" role="alert">{{ saveError }}</p>
      <button type="button" class="w-button" :disabled="!selectedClient || saving || clientBusy" @click="assignCoApplicant(selectedClient)">
        {{ saving ? 'Pridávam…' : 'Pridať spolužiadateľa' }}
      </button>
    </div>
  </div>
</template>

<script>
import ClientPicker from "../ClientPicker/ClientPicker";

export default {
  name: "ClientAddPopUp",
  components: {ClientPicker},
  props: {
    payload: [Object, null],
  },
  data: () => ({
    clientInfo: null,
    existingEmail: false,
    selectedClient: null,
    clientBusy: false,
    saving: false,
    saveError: "",
  }),
  created () {
    this.clientInfo = this.$store.getters["popupManagerState/getClientInfo"];
  },
  methods: {
    async assignCoApplicant (clientInfo) {
      if (!clientInfo || this.saving || this.clientBusy) return;
      this.saving = true;
      this.saveError = '';
      try {
        const result = await this.$store.dispatch("mortgageDetailState/addCoApplicantToMortgage", clientInfo);
        this.closePopup();
        this.$emit("set-meta", {type: "coApplicantAdd", status: "success", ...this.payload});
        if (!result?.calculationFailed) this.$store.commit("appState/setSuccessMessage", {
          text: "k hypotéke ste pridali spolužiadateľa",
          type: "success"
        });
      } catch (error) {
        this.saveError = 'Spolužiadateľa sa nepodarilo pridať. Skúste to znova.';
      } finally {
        this.saving = false;
      }
    },
    closePopup () {
      this.$store.commit("popupManagerState/popItemFromPopupOrder");
    },
    closePopupWithInfo() {
      if (this.saving) return;
      this.$emit("set-meta", {type: "coApplicantAdd", status: "aborted", ...this.payload});
      this.closePopup();
    }
  },
};
</script>

<style lang="scss" scoped>

.popup {
  width: 34%;
  position: absolute !important;
  top: 0;
  overflow-y: auto;
  transition-duration: 0.5s;
}
</style>
